import { apiClient } from '../../shared/api/apiClient';
import {
    EventsListResponseSchema,
    EventResponseSchema,
    DeleteEventResponseSchema,
    CalendarsResponseSchema,
    CustomValueResponseSchema,
    EventPayloadSchema,
} from './schemas';

// ComponentCalendar.jsx (1642
// líneas, 19 fetch()) migrado a apiClient + hooks/useCalendarData.js — mismo patrón ya usado
// en el resto de features/*/api.js. `/api/customs` (áreas horarias, vista preferida) es un
// dominio aparte (key-value genérico por usuario), no `/api/calendar*`.
export const calendarApi = {
    fetchTimeAreas: (userId) => apiClient.get(`/api/customs/${userId}/time_areas`).then((d) => CustomValueResponseSchema.parse(d)),
    saveTimeAreas: (userId, value) => apiClient.post('/api/customs', { userId, key: 'time_areas', value }),

    fetchCalendarView: (userId) => apiClient.get(`/api/customs/${userId}/calendar_view`).then((d) => CustomValueResponseSchema.parse(d)),
    // Bug preexistente encontrado al verificar esta migración: `PUT /api/customs/:userId/
    // calendar_view` nunca existió en el backend (`customSettingRouter.js` solo tiene
    // `GET /customs/:userId/:key` y `POST /customs`) — el fetch original ya apuntaba a una
    // ruta inexistente, el error quedaba silenciado por su `.catch()` sin chequear `res.ok`.
    // Se corrige usando la misma ruta genérica que ya usa `saveTimeAreas`.
    saveCalendarView: (userId, value) => apiClient.post('/api/customs', { userId, key: 'calendar_view', value }),

    fetchCalendars: (userId) => apiClient.get(`/api/calendars?userId=${userId}`).then((d) => CalendarsResponseSchema.parse(d)),

    fetchEvents: ({ start, end, onlyMine, userId, userNick, q, calendarIds }) => {
        const params = new URLSearchParams({ onlyMine: String(onlyMine) });
        if (start) params.set('start', start);
        if (end) params.set('end', end);
        if (userId) params.set('userId', userId);
        if (userNick) params.set('userNick', userNick);
        if (q) params.set('q', q);
        if (calendarIds) params.set('calendarIds', calendarIds);
        return apiClient.get(`/api/events?${params.toString()}`).then((d) => EventsListResponseSchema.parse(d));
    },
    fetchEventById: (id) => apiClient.get(`/api/events/${id}`).then((d) => EventResponseSchema.parse(d)),
    // `EventPayloadSchema.parse(payload)` valida solo el shape de SALIDA (loose, todo opcional,
    // nunca `.strict()` -- 02.5-calendar.md §4 "a′") -- no transforma el payload, mismo criterio
    // ya documentado acá abajo para `updateEvent`/`createEvent`: la forma es decisión del caller.
    createEvent: (payload) => apiClient.post('/api/events', EventPayloadSchema.parse(payload)).then((d) => EventResponseSchema.parse(d)),
    updateEvent: (id, payload) => apiClient.put(`/api/events/${id}`, EventPayloadSchema.parse(payload)).then((d) => EventResponseSchema.parse(d)),
    deleteEvent: (id) => apiClient.del(`/api/events/${id}`).then((d) => DeleteEventResponseSchema.parse(d)),

    // El resize/drag-drop puede estar moviendo un evento real o una tarea mostrada en el
    // calendario — mismo branching que ya hacía cada fetch() duplicado (líneas 707/867 del
    // componente original), consolidado acá en un solo punto.
    updateEventOrTaskTime: (event, payload) => {
        const path = event.type === 'task'
            ? `/api/tasks/${event.task_id || event.id}`
            : `/api/events/${event.id}`;
        return apiClient.put(path, payload);
    },
};
